import script from "./Preloader.vue?vue&type=script&setup=true&ts=true&lang=js"
export * from "./Preloader.vue?vue&type=script&setup=true&ts=true&lang=js"

import "./Preloader.vue?vue&type=style&index=0&id=8421ff68&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8421ff68"]])

export default __exports__